/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const queryString = require("query-string");

// You can delete this file if you're not using it
exports.onClientEntry = () => {
  
  if(typeof window !== `undefined`) {
    const campaign = queryString.parse(window.location.search).cpn;
    if ( campaign !== undefined && campaign !== null && typeof localStorage !== `undefined` ) {
      localStorage.setItem("campaign", campaign );
      console.log("Loading EngineID Experience 0.3");
    }
  }
}